import React, { useState } from 'react';
import UsersPurchasePlansAdminList from './components/UsersPurchasePlansAdminList';
import UsersPurchasePlansAdminAddPurchasePlanPage from './components/UsersPurchasePlansAdminAddPurchasePlanPage';
import { Box, Tabs, Tab } from '@mui/material';



const UsersPurchasePlansAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List user's Purchase Plans" />
        <Tab label="Insert User's Purchase Plan" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <UsersPurchasePlansAdminList />}
        {tab === 1 && <UsersPurchasePlansAdminAddPurchasePlanPage />}
      </Box>
    </Box>
  );
};

export default UsersPurchasePlansAdminPage;